import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getGuestUserDetails = async () => {
  try {
    const guestEmail = sessionStorage.getItem('guestEmail');
    const response = await instance({
      method: 'GET',
      url: `/guest/get-user-details/${guestEmail}`,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};
